import { BLUE_500, LILAC_500 } from '../colors';
var progressConfig = {
  type: 'circular',
  healthType: 'none',
  size: 'md',
  value: 0,
  backgroundColor: null,
  progressColor: BLUE_500,
  borderColor: LILAC_500,
  progressBackgroundColor: LILAC_500,
  strokeWidth: 1,
  duration: 1000,
  config: {
    size: {
      sm: {
        circular: {
          progressSize: 24,
          thickness: 2
        },
        linear: {
          thickness: 2
        }
      },
      md: {
        circular: {
          progressSize: 32,
          thickness: 3
        },
        linear: {
          thickness: 4
        }
      },
      lg: {
        circular: {
          progressSize: 40,
          thickness: 4
        },
        linear: {
          thickness: 6
        }
      }
    }
  }
};
export default {
  light: progressConfig,
  dark: progressConfig,
  white: progressConfig
};